import React from 'react';

const Message: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 1.44772 0.447715 1 1 1H23C23.5523 1 24 1.44772 24 2V17C24 17.5523 23.5523 18 23 18H13.3205L6.58124 22.8137C6.27642 23.0315 5.87549 23.0606 5.54242 22.8892C5.20935 22.7178 5 22.3746 5 22V18H1C0.447715 18 0 17.5523 0 17V2ZM2 3V16H6C6.55228 16 7 16.4477 7 17V20.0568L12.4188 16.1863C12.5884 16.0651 12.7916 16 13 16H22V3H2Z"
      />
    </svg>
  );
};

export default Message;
